// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны

export interface IOfferUnderground {
  /** Способ передвижения до метро **/
  transportType?: ETransportType;
  /** Название **/
  name: string;
  /** Цвет линии метро, hex **/
  lineColor?: string;
  /** Время в пути в минутах до метро, мин **/
  time?: number;
}

export enum ETransportType {
  /** На транспорте **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
